var map = {
	"./ambi-star-red.svg": "726c9",
	"./ambi-star.svg": "cc17",
	"./apple-pay.svg": "860d",
	"./arrow-left.svg": "088e",
	"./arrow-right.svg": "0b94",
	"./arrow-white.svg": "69f0",
	"./basket-number.svg": "7c4a",
	"./basket-number2.svg": "ac46",
	"./calendar.svg": "05e4",
	"./cart.svg": "28a6",
	"./check.svg": "91c1b",
	"./checkbox-empty.svg": "c6a0",
	"./checkbox-fill.svg": "44b8",
	"./chevron-down.svg": "2593",
	"./chevron-right.svg": "410c",
	"./chevron-up.svg": "a4f0",
	"./close.svg": "81b5",
	"./download.svg": "f3e1",
	"./error.svg": "a9b7",
	"./fe-swipe-x.svg": "1c3d",
	"./filter-check.svg": "3885",
	"./filter-karta-light.svg": "d3fb",
	"./filter-karta.svg": "4fef",
	"./filter-nahoda.svg": "ac96b",
	"./filter-objev.svg": "8fc6",
	"./filter-pitny-rezim.svg": "2035",
	"./filter-slagry.svg": "d8d54",
	"./filter-tasky-dobrot.svg": "309a",
	"./filter-um-new.svg": "35f84",
	"./filter-um.svg": "15ce",
	"./filter-vzdelavej.svg": "1a6f",
	"./filter-zranice.svg": "9dce",
	"./gopay.svg": "537e",
	"./hamburger.svg": "564f",
	"./info.svg": "4201",
	"./loading.svg": "7a8e",
	"./logo.svg": "cccd",
	"./minus.svg": "b294f",
	"./plate.svg": "c5df",
	"./play.svg": "2787",
	"./plus.svg": "54b9",
	"./price-czk.svg": "c2324",
	"./radio-empty.svg": "a158",
	"./radio-fill.svg": "559c",
	"./random.svg": "947c",
	"./scroll.svg": "c4dc",
	"./success.svg": "b62c",
	"./table.svg": "ff20",
	"./tick.svg": "db31",
	"./um.svg": "7dcb",
	"./w-money.svg": "3641",
	"./wo-money.svg": "6a39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cc9";